import { render } from "./CareerDetailsView.vue?vue&type=template&id=f04c3cde&scoped=true"
import script from "./CareerDetailsView.vue?vue&type=script&lang=js"
export * from "./CareerDetailsView.vue?vue&type=script&lang=js"

import "./CareerDetailsView.vue?vue&type=style&index=0&id=f04c3cde&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f04c3cde"]])

export default __exports__